import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { when } from "@arcgis/core/core/reactiveUtils";

import { messageBundle, storeNode, tsx } from '@arcgis/core/widgets/support/widget';

import Widget from '@arcgis/core/widgets/Widget';
import { VNode } from 'src/interfaces/interfaces';


export interface AlertWrapperProperties extends __esri.WidgetProperties {
  title: string;
  msg: string;
  type: "success" | "error";
  goToLinkId?: string;
}

const ALERT_DISMISS_TIME = 7500;

@subclass('Landing.widgets.AlertWrapper')
export default class AlertWrapper extends Widget {
  @property()
  title: string;

  @property()
  msg: string;

  @property()
  type: "success" | "error";

  @property()
  goToLinkId?: string;

  @property()
  alertNotificationDOM: HTMLCalciteAlertElement;

  @property({ readOnly: true })
  isDestroyed: boolean = false;
  
  private _alertLinkDOM: HTMLCalciteLinkElement;

  constructor(properties?: AlertWrapperProperties) {
    super(properties);
  }

  postInitialize() {
    when(() => this?.alertNotificationDOM !== undefined, ()=>{
      setTimeout(()=>{
        this.alertNotificationDOM.open = false;
        this._set("isDestroyed", true);
      }, ALERT_DISMISS_TIME);
    }, {
      initial: true,
      once: true
    });
  }

  render() {
    return (
      <calcite-alert
        afterCreate={storeNode}
        bind={this}
        data-node-ref="alertNotificationDOM"
        open={true}
        scale="m"
        kind={this.type === "success" ? "success" : "danger"}
      >
        <div
          slot="title"
          afterCreate={storeNode}
          bind={this}
          data-node-ref="_alertTitleDOM"
        >
          {this.title}
        </div>
        <div
          slot="message"
          afterCreate={storeNode}
          bind={this}
          data-node-ref="_alertMsgDOM"
        >
          {this.msg}
        </div>
        {/* 
        TODO: implement Go To Link
        <calcite-link
          slot="link"
          title={goTo}
          afterCreate={storeNode}
          bind={this}
          data-node-ref="alertLinkDOM"
          onclick={(e) => {
            // go to proper page
            console.log("LINK CLICK", e);
          }}
        > {goTo}
        </calcite-link> */}
      </calcite-alert>
    )
  }



}
